import BatteryDark from './dark/battery_dark.svg';
import ManDark from './dark/man_dark.svg';
import MechanicDark from './dark/mechanic_dark.svg';
import PaintGunDark from './dark/paint_gun_dark.svg';
import PeopleDark from './dark/people_dark.svg';
import PhoneDark from './dark/phone_dark.svg';
import VanDark from './dark/van_dark.svg';
import WheelDark from './dark/wheel_dark.svg';
import WomanDark from './dark/woman_dark.svg';
import WrenchDark from './dark/wrench_dark.svg';

import BatteryLight from './light/battery_light.svg';
import ManLight from './light/man_light.svg';
import MechanicLight from './light/mechanic_light.svg';
import PaintGunLight from './light/paint_gun_light.svg';
import PeopleLight from './light/people_light.svg';
import PhoneLight from './light/phone_light.svg';
import VanLight from './light/van_light.svg';
import WheelLight from './light/wheel_light.svg';
import WomanLight from './light/woman_light.svg';
import WrenchLight from './light/wrench_light.svg';

export {
  BatteryDark,
  ManDark,
  MechanicDark,
  PaintGunDark,
  PeopleDark,
  PhoneDark,
  VanDark,
  WheelDark,
  WomanDark,
  WrenchDark,
  BatteryLight,
  ManLight,
  MechanicLight,
  PaintGunLight,
  PeopleLight,
  PhoneLight,
  VanLight,
  WheelLight,
  WomanLight,
  WrenchLight,
};
